import {Icon} from '@startlibs/components';
import {formatDate, getColor, media} from '@startlibs/utils';
import React from 'react'
import _ from 'lodash/fp'
import styled from 'styled-components'
import {getDateValue} from '../../utils/utils'
import {lazyUserInfo} from '../WithProvider'
import {lazyUserCategories} from '../../admin/experts/hooks/useEditCategories'
import {lazyAdminUsers} from './AdvancedSearchPopup'
import {OPERATOR} from '../../enums/UserRole'
import {defaultDateFormat} from "../../utils/dateFormat";
import {FormattedMessage, useIntl} from "react-intl";


const ActiveFilters = styled.div `
  margin-bottom: -1.25rem;
  ${media.max(800) `
    margin-bottom: -0.75rem;
  `}
  margin-top: 0.5rem;
  > span {
    margin-top: 0.25rem;
    background: rgba(0,0,0,0.075);
    border-radius: 50px;
    padding: 0 0.5rem;
    margin-left: 0.25rem;
    line-height: 2rem;
    display: inline-block;
  }
  > span:hover {
    background: rgba(0,0,0,0.1);
    cursor: pointer;
  }
  ${props => props.popupIsOpen && `
    opacity: 0.4;
    pointer-events: none;
  `}
  ${Icon} {
    background: rgba(0,0,0,0.075);
    border-radius: 50%;
    width: 18px;
    height: 18px;
    line-height: 18px;
    margin: 0 -0.25rem 0 0.25rem;
    text-align: center;
    display: inline-block;
    vertical-align: -1px;
    :hover {
      background: #dec0c1;
      color: ${getColor('alert')};
    }
  }
  a {
    color: inherit;
    text-decoration: none;
  }
`

export const ActiveAdvancedFilters = ({advancedPopup,params,setParams,lazyCategories = lazyUserCategories, divisionsFilter, setDivisionsFilter, isExpert}) => {
  const intl = useIntl()
  const categories = lazyCategories ? lazyCategories.read() : []
  const userInfo = lazyUserInfo.read()

  const dob = getDateValue('dob',params)
  const from = getDateValue('from',params)
  const to = getDateValue('to',params)
  // const categoriesInUse = (params.categories||"").split("|").map(key =>categories.find(({id})=>id.toString()===key)).filter(Boolean)
  const divisionsInUse = (divisionsFilter||"").split("|").map(key =>categories.find(({id})=>id.toString()===key)).filter(Boolean)
  const uploadDateSameDay = to && from && to.getTime() === from.getTime()

  const allUsers = isExpert ? [] : userInfo.role === OPERATOR ? [userInfo] : lazyAdminUsers.read()
  const coordinatorIds = (params.coordinatorIds || "").split("|").filter(Boolean)
  const selectedCoordinators = coordinatorIds.map(id => allUsers.find(u => u.id.toString() === id)).filter(Boolean)

  // const hasFilters = dob || from || to || userInfo.categories?.length > 0 || categoriesInUse.length > 0
  const hasFilters = dob || from || to || userInfo.categories?.length > 0 || divisionsInUse.length > 0 || (!isExpert && coordinatorIds.length > 0)

  const removeKeys = (...keys) => (e) => {
    keys.forEach(key => {
      setParams(_.unset(key))
    })
    e.stopPropagation()
  }


  if (!hasFilters) return null



  return <ActiveFilters popupIsOpen={advancedPopup.isOpen}>
    <b><FormattedMessage
      defaultMessage="Filtering"
      description="Active advanced filters"
    />:</b>
    {/* {
      !!categoriesInUse.length && <span onClick={advancedPopup.willOpenWith("categories")}>Cases from <span>{categoriesInUse.map(({name})=> name).join(", ")}</span> division{categoriesInUse?.length > 1 && "s"}<a onClick={removeKeys("categories")}><Icon icon="x"/></a></span>
    } */}
    {
      !!divisionsInUse?.length && <span onClick={advancedPopup.willOpenWith("categories")}>
        <FormattedMessage
          defaultMessage="Cases from <span>{divisions}</span> division{divisionQuantity, plural, one {} other {s}}"
          description="Active advanced filters, divisions in use"
          values={{
            divisions:divisionsInUse.map(({name})=> name).join(", "),
            divisionQuantity:divisionsInUse.length,
            span: (chunks) => <span>{chunks}</span>
          }}
        /><a onClick={
        (e) => {
          removeKeys("categories")(e)
          setDivisionsFilter('')
        }
      }><Icon icon="x"/></a></span>
    }
    {
      userInfo.categories?.length >= 1 && !divisionsInUse.length && <span>
        <FormattedMessage
          defaultMessage="Cases from <span>{divisions}</span> division{divisionQuantity, plural, one {} other {s}}"
          description="Active advanced filters, divisions in use"
          values={{
            divisions: userInfo.categories.map(({name})=> name).join(", "),
            divisionQuantity: userInfo.categories.length,
            span: (chunks) => <span>{chunks}</span>
          }}
        /></span>}
    {
      !isExpert && !!coordinatorIds.length && <span onClick={advancedPopup.willOpenWith("coordinators")}>
        <FormattedMessage
          defaultMessage="Coordinator{count, plural, one {} other {s}}: <span>{names}</span>"
          description="Active advanced filters, coordinators"
          values={{
            count: selectedCoordinators.length,
            names: selectedCoordinators.map(u => `${u.firstName} ${u.lastName}`).join(", "),
            span: (chunks) => <span>{chunks}</span>
          }}
        /><a onClick={removeKeys('coordinatorIds')}><Icon icon="x"/></a>
      </span>
    }
    {
      !!dob && <span onClick={advancedPopup.willOpenWith("dob")}><FormattedMessage
          defaultMessage="DOB"
          description="Active advanced filters, date of birth label"
        />: {formatDate(dob,defaultDateFormat(intl))}<a onClick={removeKeys("dob")}><Icon icon="x"/></a></span>
    }
    {
      !uploadDateSameDay && !!to && !!from && <span onClick={advancedPopup.willOpenWith("from")}><FormattedMessage
        defaultMessage="Created between: {init} and {end}"
        description="Active advanced filters, created between"
        values={{
          init:formatDate(from,defaultDateFormat(intl)),
          end:formatDate(to,defaultDateFormat(intl))
        }}
      /> <a onClick={removeKeys('to','from')}><Icon icon="x"/></a></span>
    }
    {
      !!uploadDateSameDay && <span onClick={advancedPopup.willOpenWith("from")}><FormattedMessage
        defaultMessage="Created on"
      description="Active advanced filters, created on"
        />: {formatDate(from,defaultDateFormat(intl))} <a onClick={removeKeys('from', 'to')}><Icon icon="x"/></a></span>
    }
    {
      !to && !!from && <span onClick={advancedPopup.willOpenWith("from")}><FormattedMessage
        defaultMessage="Created after"
        description="Active advanced filters, created after"
        />: {formatDate(from,defaultDateFormat(intl))} <a onClick={removeKeys('from')}><Icon icon="x"/></a></span>
    }
    {
      !!to && !from &&
      <span onClick={advancedPopup.willOpenWith("to")}><FormattedMessage
        defaultMessage="Created before"
        description="Active advanced filters, created before"
        />: {formatDate(to,defaultDateFormat(intl))}<a onClick={removeKeys('to')}><Icon icon="x"/></a></span>
    }
  </ActiveFilters>
}
